import { render } from "./beweging-step.vue?vue&type=template&id=4e3cd36e"
import script from "./beweging-step.vue?vue&type=script&lang=js"
export * from "./beweging-step.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__